const servicesCompensatoryManagementRoute = {
  path: 'provider',
  component: () =>
    import('@/views/provider/services-compensatory-management/Wrapper.vue'),
  children: [
    {
      path: '/provider/services-compensatory-management',
      name: 'servicesCompensatoryManagementSearch',
      component: () =>
        import('@/views/provider/services-compensatory-management/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['rempro.provider.servicemanagement'],
        },
      },
    },
    {
      path:
        '/provider/services-compensatory-management/compensatoryService/:requestId/:academicYearId',
      name: 'compensatory-service',
      component: () =>
        import(
          '@/views/provider/services-compensatory-management/components/CompensatoryService.vue'
        ),
      props: (route) => ({
        requestId: route.params.requestId,
        academicYearId: route.params.academicYearId,
        isReadOnly: true,
      }),
    },
    {
      path: '/provider/services-closing-analysis/:requestId',
      name: 'servicesClosingAnalysis',
      component: () =>
        import(
          '@/views/provider/services-compensatory-management/RequestClosingAnalysis.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['rempro.provider.servicemanagement'],
        },
      },
    },
  ],
};

export default servicesCompensatoryManagementRoute;
